const getSystemInfo = async () => {
  const u = navigator.userAgent
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 是否为ios设备
  const isPC = typeof window.orientation === 'undefined' // 是否为PC端
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 是否为android端
  const isWx = u.toLocaleLowerCase().indexOf('micromessenger') > -1 // 判断是否为微信浏览器
  const isPhoneX = /iphone/gi.test(navigator.userAgent) && screen.height >= 812 && screen.width >= 375
  const isNfPlus = await window.nfplusJsbridge.getInsideVersion()
  const os = {
    ios: isIOS,
    pc: isPC,
    android: isAndroid,
    isWx: isWx,
    isPhoneX: isPhoneX,
    isNfPlus: !!isNfPlus
  }
  return os
}

export default getSystemInfo

export function IsPC () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0 && userAgentInfo.indexOf('Mac OS') === -1) {
      flag = false
      break
    }
  }
  return flag
}

export function isMobile () {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

export function isAndroid () {
  return /Android/i.test(navigator.userAgent)
}

export function isIOS () {
  return /iPhone|iPad/i.test(navigator.userAgent)
}

export function isNfPlus () {
  return /NFAPP/i.test(navigator.userAgent)
}

export function isWeChat () {
  return /MicroMessenger/i.test(navigator.userAgent)
}
